import React, { useRef, useState } from 'react';
import SharedTitle from '../../Components/SharedForms/SharedTitle';
import { AUT_SANITARIA, AUT_SANITARIA_DEMOSTRACION, AUT_SANITARIA_INSTALACION, LOREM_IPSUM, PRIVADOS, PUBLICOS, TEXT_COLOR_FT } from 'config/config';
import { useEffect } from 'react';

import { deleteAutorizacionSanitaria, getAutoridadesPorRegion, getFichaTecnica, postCreateAutorizacionSanitaria } from 'services/api';
import { useSelector } from 'react-redux';
import Spinner from '@jumbo/components/custom/Spinner';
import SharedWarning from '../../Components/SharedForms/SharedWarning';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, Select, Tooltip } from '@material-ui/core';
//import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';

import DialogAgregar from './DialogAgregar';
import { AddBoxOutlined, Delete } from '@material-ui/icons';
import DataTable from './AutoSanitariaCustomTable';
import { formatDateToDDMMYYYY } from '../../ConstsAndUtils/utils';

const headCells = [
  { id: 'nro_resolucion', label: 'Nº Resolución', type: 'text', shown: true },
  { id: 'fecha_mostrar', label: 'Fechan en que se otorga', type: 'date', shown: true },
  { id: 'nom_autoridad', label: 'Autoridad que la dicta', type: 'select', shown: true },
  { id: 'tipo_mostrar', label: 'Tipo autorización', type: 'select', shown: true },


]


const AutorizacionSanitariaForm = (props) => {

  const { user } = useSelector(({ claveUnica }) => claveUnica);

  const [showAgregar, setShowAgregar] = useState(false)

  const [nResolucionAgregar, setNResolucionAgregar] = useState('')
  const [fechaOtorgadaAgregar, setFechaOtorgadaAgregar] = useState('')
  const [autoridadQueDictaAgregar, setAutoridadQueDictaAgregar] = useState(0)


  const [autorizacionAdicional, setAutorizacionAdicional] = useState([])
  const [demostracionAdicional, setDemostracionAdicional] = useState([])

  const [reload, setReload] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  const [autoridadesAux, setAutoridadesAux] = useState([/* { value: 0, label: 'Seleccione' }, */])

  const agregarBtnRef = useRef();

  useEffect(() => {

    if (autoridadesAux.length === 0) {
      getAutoridadesPorRegion(sessionStorage.getItem('region'))
        .then(res => {
          let aux = res.data.map(item => ({
            value: item.id,
            label: item.nombre
          }));
          //setAutoridadesAux([{ value: 0, label: 'Seleccione' }, ...aux])
          setAutoridadesAux(aux)
        })
        .catch(e => console.error(e))
        .finally(f => {

        })
    }

  }, [])

  const closeAgregar = () => {
    setShowAgregar(false)
    setNResolucionAgregar('')
    setFechaOtorgadaAgregar('')
    setAutoridadQueDictaAgregar(0)
  }

  useEffect(() => {

    setIsLoading(true)
    var auxUser = {};
    try {
      auxUser = JSON.parse(user);
    } catch (error) {
      auxUser = user;
    }

    if (autoridadesAux.length === 0) {
      //setReload(!reload)
    } else {
      getFichaTecnica(auxUser.organization.name)
        .then(res => {
          switch (sessionStorage.getItem("tipo_administracion")) {
            case PRIVADOS: setDataPrivados(res.data.autorizaciones_sanitaria)
              break
            case PUBLICOS: setDataPublicos(res.data.autorizaciones_sanitaria)
              break
            default:
          }
        })
        .catch(e => console.error(e))
        .finally(f => {
          setIsLoading(false)
        })
    }



    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, autoridadesAux])

  const setDataPrivados = (autorizaciones) => {
    let autorizacionesArr = []

    autorizaciones.map((item, index) => {

      let autaux2 = autoridadesAux.find(e => item.id_autoridad === e.value)

      if (item.tipo === "instalación") {
        autorizacionesArr.push(
          {
            nro_resolucion: item.nro_resolucion,
            id_autoridad: item.id_autoridad,
            id: item.id,
            fecha_resolucion: item.fecha_resolucion,
            fecha_mostrar: formatDateToDDMMYYYY(item.fecha_resolucion),
            nom_autoridad: autaux2.label,
            tipo_mostrar: item.tipo.toUpperCase()
          }
        )
      } else {


      }

      return null
    })
    autorizacionesArr.sort((a, b) => a.id - b.id);
    setAutorizacionAdicional(autorizacionesArr)
  }

  const setDataPublicos = (autorizaciones) => {

    let autorizacionesArr = []
    //let demostraciones = []
    autorizaciones.map((item, index) => {

      let autaux2 = autoridadesAux.find(e => item.id_autoridad === e.value)

      /*       if (item.tipo === "instalación") {
              autorizacionesArr.push(
                {
                  nro_resolucion: item.nro_resolucion,
                  id_autoridad: item.id_autoridad,
                  id: item.id,
                  fecha_resolucion: item.fecha_resolucion,
                  nom_autoridad: autaux2.label
                }
              )
            } else {
      
              demostraciones.push(
                {
                  nro_resolucion: item.nro_resolucion,
                  id_autoridad: item.id_autoridad,
                  id: item.id,
                  fecha_resolucion: item.fecha_resolucion,
                }
              )
            } */
      autorizacionesArr.push(
        {
          nro_resolucion: item.nro_resolucion,
          id_autoridad: item.id_autoridad,
          id: item.id,
          fecha_resolucion: item.fecha_resolucion,
          fecha_mostrar: formatDateToDDMMYYYY(item.fecha_resolucion),
          nom_autoridad: autaux2.label,
          tipo_mostrar: item.tipo.toUpperCase()
        }
      )

      return null
    })

    autorizacionesArr.sort((a, b) => a.id - b.id);
    //demostraciones.sort((a, b) => a.id - b.id);
    setAutorizacionAdicional(autorizacionesArr)
    //setDemostracionAdicional(demostraciones)
  }

  const postPrivados = (aut, type) => {
    setIsLoading(true);

    const datosPrest = JSON.parse(sessionStorage.getItem("prft"));
    const id_ficha = sessionStorage.getItem("idFicha");

    const createItem = (item, tipo) => ({
      id: item.id || undefined,
      id_prestador: datosPrest.i,
      rut_prestador: datosPrest.r,
      id_ficha_tecnica: parseInt(id_ficha),
      nro_resolucion: item.nro_resolucion,
      fecha_resolucion: item.fecha_resolucion,
      id_autoridad: item.id_autoridad,
      tipo,
    });

    //const auxArr = aut.map(item => createItem(item, "instalación"));
    const auxArr = aut.map((item, index) => {

      if (item.tipo_mostrar) {
        return createItem(item, item.tipo_mostrar.toLowerCase())
      } else {
        return createItem(item, "instalación")
      }

    });

    postCreateAutorizacionSanitaria(auxArr)
      .then((res) => {
        if (type === "post") {
          toast.success('Autorización sanitaria agregada.')
        }
        else {
          toast.success('Datos guardados.')
        }

      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.detail) {
          console.error(e.response.data.detail);
          toast.error(e.response.data.detail);
        } else {
          console.error("Error:", e.message);
        }
      })
      .finally(() => {
        setReload(!reload);
      });
  };


  const postPublicos = (aut, demo, type) => {
    setIsLoading(true);

    const datosPrest = JSON.parse(sessionStorage.getItem("prft"));
    const id_ficha = sessionStorage.getItem("idFicha");

    const createItem = (item, tipo) => ({
      id: item.id || undefined,
      id_prestador: datosPrest.i,
      rut_prestador: datosPrest.r,
      id_ficha_tecnica: parseInt(id_ficha),
      nro_resolucion: item.nro_resolucion,
      fecha_resolucion: item.fecha_resolucion,
      id_autoridad: item.id_autoridad,
      tipo,
    });

    const auxArr = [
      ...aut.map(item => createItem(item, "instalación")),
      ...demo.map(item => createItem(item, "demostración")),
    ];

    postCreateAutorizacionSanitaria(auxArr)
      .then((res) => {
        if (type === "post") {
          toast.success('Autorización sanitaria agregada.')
        }
        else {
          toast.success('Datos guardados.')
        }
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.detail) {
          console.error(e.response.data.detail);
          toast.error(e.response.data.detail);
        } else {
          console.error("Error:", e.message);
        }
      })
      .finally(() => {
        setReload(!reload);
      });
  };

  const tipoAdministracion = sessionStorage.getItem("tipo_administracion");

  const isUpdateDisabled = () => {
    if (tipoAdministracion === PRIVADOS) {
      return autorizacionAdicional.length === 0;
    }
    if (tipoAdministracion === PUBLICOS) {
      return autorizacionAdicional.length === 0 && demostracionAdicional.length === 0;
    }
    return true; // default to disabled if unknown
  };


  const postAutSanitaria = (auxAut, auxDemo) => {
    switch (sessionStorage.getItem("tipo_administracion")) {
      case PRIVADOS: postPrivados(auxAut, "post")
        break
      case PUBLICOS: postPublicos(auxAut, auxDemo, "post")
        break
      default:
    }
  }

  const handleUpdateClick = (data) => {
    /*     const tipoAdmin = sessionStorage.getItem("tipo_administracion");
    
        if (tipoAdmin === PRIVADOS) {
          postPrivados(autorizacionAdicional, "update");
        } else if (tipoAdmin === PUBLICOS) {
          postPublicos(autorizacionAdicional, demostracionAdicional, "update");
        } */

    let updatedArray = autorizacionAdicional.map(item => item.id === data.id ? data : item)
    postPrivados(updatedArray, "update")
  };


  const handleDelete = (index, tipo) => {

    setIsLoading(true)
    deleteAutorizacionSanitaria(index.id)
      .then(res => {
        setReload(!reload)
        toast.success("Autorización sanitaria eliminada")
      })
      .catch(e => console.error(e))
      .finally(f => {
        setIsLoading(false)
      })
  }

  const agregarNuevaAutorizacion = (tipo) => {
    const nro_resolucion = nResolucionAgregar;
    const fecha_resolucion = fechaOtorgadaAgregar;
    const id_autoridad = autoridadQueDictaAgregar;
    const newItem = { nro_resolucion, fecha_resolucion, id_autoridad };

    setNResolucionAgregar('');
    setFechaOtorgadaAgregar('');
    setAutoridadQueDictaAgregar(0);

    let auxAut = [...autorizacionAdicional];
    let auxDemo = [...demostracionAdicional];
    if (tipo === "instalacion") {
      auxAut.push(newItem);
    } else {
      auxDemo.push(newItem);
    }

    postAutSanitaria(auxAut, auxDemo);

    closeAgregar();
  };



  return (
    <><Spinner show={isLoading} />
      <div style={{ width: '100%', flexBasis: '100%', color: TEXT_COLOR_FT, backgroundColor: 'white' }}>

        <SharedTitle
          title={'Autorización Sanitaria'}
        />
        <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 15, paddingBottom: 15, paddingRight: 25, paddingLeft: 25 }}>
          <p>{AUT_SANITARIA}</p>
          <p style={{ marginTop: 15 }}>{AUT_SANITARIA_INSTALACION}</p>
          {tipoAdministracion === PUBLICOS ?
            <p style={{ marginTop: 15 }}>{AUT_SANITARIA_DEMOSTRACION}</p>
            :
            null
          }
        </Grid>

        <Grid container item xs={12} justifyContent='flex-start' spacing={2}
          style={{ marginTop: 40, flexBasis: '0%', marginBottom: 10, paddingRight: 10, paddingLeft: 15 }}
        >
          <Grid item xs={3}>
            <Button
              startIcon={<AddBoxOutlined />}
              ref={agregarBtnRef}
              variant='outlined'
              color='primary'
              fullWidth
              onClick={() => {
                if (agregarBtnRef.current) {
                  agregarBtnRef.current.blur();
                }
                setShowAgregar(true);
              }}
            >
              Agregar Autorización
            </Button>
          </Grid>

        </Grid>

        <Grid container item xs={12} justifyContent='flex-start' spacing={2}
          style={{ marginTop: 40, flexBasis: '0%', marginBottom: 10, paddingRight: 10, paddingLeft: 15 }}
        >
          {
            autorizacionAdicional.length === 0 ? null :
              <DataTable
                headCells={headCells}
                rows={autorizacionAdicional}
                handleDelete={handleDelete}
                reloadTable
                autoridades={autoridadesAux}
                handleSave={handleUpdateClick}
              />
          }
        </Grid>

      </div>



      <DialogAgregar
        open={showAgregar}
        close={closeAgregar}
        action={agregarNuevaAutorizacion}
        nResolucion={nResolucionAgregar}
        fechaOtorgada={fechaOtorgadaAgregar}
        autoridadQueDicta={autoridadQueDictaAgregar}
        setNResolucion={setNResolucionAgregar}
        setFechaOtorgada={setFechaOtorgadaAgregar}
        setAutoridadQueDicta={setAutoridadQueDictaAgregar}
        publico={sessionStorage.getItem('tipo_administracion')}

      />
      <CustomToast />
    </>
  )

}

export default AutorizacionSanitariaForm